import { GisEntityName } from './gis.models';

/** Adres bloklarındaki harita butonlarının türü. */
export type GisAdresHedefTuru = 'PARSEL' | 'BINA' | 'BOLUM' | 'KAPI' | 'CADDE' | 'MAHALLE';

/** Adres bloğundaki DaB kodları (formdaki alanlar). */
export interface GisAdresKaynagi {
  parselKod?: number | null;
  binaKod?: number | null;
  adresKod?: number | null;
  /** GenMahalleCaddeSokak.Kod — haritada karşılığı yok; bağlı olduğu mahalle ve caddeye çözülür. */
  mahalleCaddeKod?: number | null;
}

/** Bir MahalleCaddeKod'un bağlı olduğu mahalle (GenMahalleKoy.Kod) ve cadde (GenCaddeSokak.Kod). */
export interface GisMahalleCadde {
  mahalleKod: number | null;
  caddeSokakKod: number | null;
}

export interface GisHaritaHedefi {
  entityName: GisEntityName;
  entityId: number;
}

const UYARILAR: Record<GisAdresHedefTuru, string> = {
  PARSEL: 'Lütfen Parsel Seçiniz...',
  BINA: 'Lütfen Bina Seçiniz...',
  BOLUM: 'Lütfen Bina/Bölüm Seçiniz...',
  KAPI: 'Lütfen Kapı Seçiniz...',
  CADDE: 'Lütfen Mahalle/Cadde Seçiniz...',
  MAHALLE: 'Lütfen Mahalle Seçiniz...',
};

function kod(value: number | null | undefined): number | null {
  const n = Number(value);
  return value != null && Number.isFinite(n) && n > 0 ? n : null;
}

/**
 * Adres bloğundaki harita butonu için haritada gösterilecek nesneyi belirler.
 *  - BOLUM: haritada bölüm katmanı yok → bölümün binası gösterilir.
 *  - CADDE / MAHALLE: `mahalleCadde` (MahalleCaddeKod'un çözülmüş hali) kullanılır;
 *    CADDE için cadde kodu yoksa mahalle gösterilir.
 * Gösterilecek kod yoksa null döner.
 */
export function gisAdresHedefi(
  tur: GisAdresHedefTuru,
  kaynak: GisAdresKaynagi,
  mahalleCadde?: GisMahalleCadde | null
): GisHaritaHedefi | null {
  const hedef = (entityName: GisEntityName, id: number | null | undefined): GisHaritaHedefi | null => {
    const entityId = kod(id);
    return entityId == null ? null : { entityName, entityId };
  };
  switch (tur) {
    case 'PARSEL':
      return hedef('PARSEL', kaynak.parselKod);
    case 'BINA':
    case 'BOLUM':
      return hedef('BINA', kaynak.binaKod);
    case 'KAPI':
      return hedef('KAPI', kaynak.adresKod);
    case 'CADDE':
      return hedef('CADDE', mahalleCadde?.caddeSokakKod) ?? hedef('MAHALLE', mahalleCadde?.mahalleKod);
    case 'MAHALLE':
      return hedef('MAHALLE', mahalleCadde?.mahalleKod);
  }
}

export function gisAdresHedefUyarisi(tur: GisAdresHedefTuru): string {
  return UYARILAR[tur];
}
